import * as THREE from "three"
import "./style.css"
import CANNON from "cannon"
import initDesktopControls from './desktopControls.js'
import initMobileControls from './mobileControls.js'
import {CannonVehicle }from './raycastVehicle.js';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader'
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls.js"
import {meshToHeightField,defaultHeightField} from "./terrainHelper.js"
import {RGBELoader} from "three/examples/jsm/loaders/RGBELoader.js"
import {initChaseCamera, updateChaseCamera} from "./cameraHelper.js"
import ThreeMeshUI from 'three-mesh-ui'
import {SpatialSound} from './spatialSound.js'
import {ProjectInfoInteractable} from "./projectInfoInteractable.js"
import {RadioInteractable} from "./radioInteractable.js"
import {threeToCannon, ShapeType} from 'three-to-cannon'



window.mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

const worldStep = 1/60

const gWorld = new CANNON.World()
gWorld.boradphase = new CANNON.SAPBroadphase(gWorld)
gWorld.gravity.set(0,-10,0)
gWorld.defaultContactMaterial.friction = 0.001
const gScene = new THREE.Scene()
const canvas = document.querySelector("#c")
const gRenderer = new THREE.WebGLRenderer({canvas, antialias: true, alpha: true})
gRenderer.shadowMap.enabled = true
// const gCamera = new THREE.PerspectiveCamera(50,  canvas.clientWidth / canvas.clientHeight, 0.1, 1000)
let gCamera = new THREE.PerspectiveCamera(45, canvas.clientWidth/canvas.clientHeight, 0.1, 300)
gCamera.position.x = 30
gCamera.position.y = 125
gCamera.position.z = -4


const controls = new OrbitControls(gCamera,canvas)
controls.target.set(0,5,0)
controls.update()

const directionalLight = new THREE.DirectionalLight(0xffffff, 500)
directionalLight.castShadow = true
directionalLight.position.set(-20,130,-30) 
directionalLight.target.position.set(7.5,115,0)
// const cameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
directionalLight.shadow.camera['left'] = -15
directionalLight.shadow.camera['right'] = 15
directionalLight.shadow.camera['bottom'] = -15
directionalLight.shadow.camera['top'] = 15
directionalLight.shadow.mapSize.width = 1024
directionalLight.shadow.mapSize.height = 1024
directionalLight.shadow.camera.updateProjectionMatrix();
// cameraHelper.update();
gScene.add(directionalLight)
gScene.add(directionalLight.target)
// gScene.add(cameraHelper)
gCamera.lookAt(7.5,115,0)

let mainSceneVisible = false
const mainMeshes = {
}

const loadingScreenMeshes = {

} 
const cannonVehicle = new CannonVehicle()

let spatialSound = new SpatialSound()
let interactables = []

let ephemerisInfoInteractable = new ProjectInfoInteractable({x: -130,y:  20, z: -230}, {x: -1.1, y: 1.8},"React app helping moviegoers minimize downtime between showings.", "https://ephemeris.xyz/" )
let boomBoxInteractable = new RadioInteractable(spatialSound)
let elastimatchInfoInteractable = new ProjectInfoInteractable({x: -134,y:  20, z: -250}, {x: -1.1, y: 1.8},"React app helping instructors easily form groups for activities.", "https://www.elastimatch.com/" )
interactables.push(ephemerisInfoInteractable)
interactables.push(elastimatchInfoInteractable)
interactables.push(boomBoxInteractable)
let loadingSceneLoaded = false
let mainSceneLoaded = false

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () => {
        if(!loadingSceneLoaded){
            loadingSceneLoaded = true
            loadMainScene()
        }
        else if(!mainSceneLoaded && loadingSceneLoaded){
            mainSceneLoaded = true
            makeMainSceneVisible()
        }
    },
    //Progress
    (itemUrl, itemsLoaded, itemsTotal) => 
    {
        let loadedRatio = itemsLoaded / 18

        if(directionalLight.position.z < 30){
            directionalLight.position.set(-20, 130, -30 + (60 * loadedRatio))
        }
    }
)
let rtTexture
let objectsToUpdate = []
const gltfLoader = new GLTFLoader(loadingManager);
const dracoLoader = new DRACOLoader(); 
dracoLoader.setDecoderPath('./draco/')
gltfLoader.setDRACOLoader(dracoLoader)
const textureLoader = new THREE.TextureLoader(loadingManager)

function loadMainScene(){

    const bakingColorDecor = textureLoader.load("./DecorBakeCompressed.png")
    const bakingColorJeep = textureLoader.load("./JeepBakeCompressed.png")
    const bakingColorCliff = textureLoader.load("./LowPolyCliffBakeCompressed.png")
    const bakingColorTerrain = textureLoader.load("./3kTerrainBakeCompressed.png")
    const bakingColorNature = textureLoader.load("./2kNatureBakeCompressed.png")
    const bakingAlphaNature = textureLoader.load("./2kNatureBakeAlphaCompressed.png")
    const bakingColorAirstream = textureLoader.load("./2kAirstreamBakeCompressed.png")




    bakingColorDecor.flipY = false
    bakingColorJeep.flipY = false
    bakingColorCliff.flipY = false
    bakingColorTerrain.flipY = false
    bakingColorNature.flipY = false
    bakingAlphaNature.flipY = false
    bakingColorAirstream.flipY = false


    const decorMaterial = new THREE.MeshBasicMaterial({map: bakingColorDecor})
    const jeepMaterial = new THREE.MeshBasicMaterial({map: bakingColorJeep})
    const cliffMaterial = new THREE.MeshBasicMaterial({map: bakingColorCliff})
    const terrainMaterial = new THREE.MeshBasicMaterial({map: bakingColorTerrain})
    const natureMaterial = new THREE.MeshBasicMaterial({map: bakingColorNature, alphaMap: bakingAlphaNature, transparent: true})
    const natureDepthlessMaterial = new THREE.MeshBasicMaterial({map: bakingColorNature, alphaMap: bakingAlphaNature, transparent: true})
    const airstreamMaterial = new THREE.MeshBasicMaterial({map: bakingColorAirstream})
    
    natureMaterial.alphaTest = 0.75
    natureDepthlessMaterial.depthWrite = false


    const cannonTumbleweedMaterial = new CANNON.Material('tumbleweed')
    const cannonTerrainMaterial = new CANNON.Material('terrain')
    const cannonTumbleweedTerrainContactMaterial = new CANNON.ContactMaterial(
        cannonTumbleweedMaterial,
        cannonTerrainMaterial,
        {
            friction: 0.9,
            restitution: 0.1
        }
    )
    gWorld.addContactMaterial(cannonTumbleweedTerrainContactMaterial)

    

    
    gltfLoader.load('./AddedNatureblend.glb', (mainSceneGLB) => {

        gScene.add(mainSceneGLB.scene)
        mainSceneGLB.scene.traverse((child) => {
            mainMeshes[child.name] = child
          
            child.visible = false
            if (child.isMesh && child.name.includes("Jeep")) {
            
                if(child.name.toLowerCase().includes("wheel")){
                    child.material = jeepMaterial
                }
                else{
                    child.material = jeepMaterial
                }
            
            }
            else if(child.isMesh && child.name.toLowerCase().includes("airstream")){
                child.material = airstreamMaterial
            }
            
            else if  (child.isMesh && child.name.toLowerCase().includes("terrain")) {
                child.material = terrainMaterial
                child.material.side= THREE.DoubleSide
            }
            else if(child.isMesh && child.name.toLowerCase().includes("collider")){
                const newbox = threeToCannon(child, {type: ShapeType.Box})
                const body = new CANNON.Body({mass:0});
                body.addShape(newbox.shape);
                body.position.copy(child.position);
                body.quaternion.copy(child.quaternion);
                gWorld.add(body);
            }
            else if  (child.isMesh && child.name.toLowerCase().includes("nature") ) {
                if(child.name.toLowerCase().includes("grass") ){
                    child.material = natureDepthlessMaterial 
                }
                else{
                    child.material = natureMaterial 
                }
            }  
            else if  (child.isMesh && child.name.toLowerCase().includes("cliff") ) {
       
                child.material = cliffMaterial
            }  
            else if  ( child.isMesh && child.name.toLowerCase().includes("decor") ) {
                child.material = decorMaterial
                if(child.name.toLowerCase().includes("tumbleweed")){
                    const shape = new CANNON.Sphere(7)
                    const body = new CANNON.Body({
                        mass: 20,
                        position: child.position,
                        shape: shape,
                        material: cannonTumbleweedMaterial
                    })
                    body.position.copy(child.position)
                    gWorld.addBody(body)
                    objectsToUpdate.push({mesh: child, body: body})
                }
            }  
        });

        let terrainHeightField = defaultHeightField()
    
        // let terrainHeightField = meshToHeightField(mainMeshes["Terrain"], 20)
        terrainHeightField.material = cannonTerrainMaterial

        gWorld.addBody(terrainHeightField)
        cannonVehicle.addMeshesToWorld(gWorld, mainMeshes)
        
    
    })

}


function makeMainSceneVisible(){
    for(const mesh in mainMeshes){
        if(!mainMeshes[mesh].name.toLowerCase().includes("collider")){
            mainMeshes[mesh].visible = true
        }
        
    }
    for(const mesh in loadingScreenMeshes){
        loadingScreenMeshes[mesh].visible = false
    }
   

    directionalLight.visible = false
    const sunLight1 = new THREE.DirectionalLight(0xffffff, 1)
    sunLight1.position.set(3000, 1000,0)
    sunLight1.target.position.set(0, 0,0)

    gScene.add(sunLight1)
    const sunLight2 = new THREE.DirectionalLight(0xffffff, 1)
    sunLight2.position.set(-3000, 1000,0)
    sunLight2.target.position.set(0, 0,0)
    gScene.add(sunLight2)
    const sunLight3 = new THREE.DirectionalLight(0xffffff, 1)
    sunLight3.position.set(0, 1000,-3000)
    sunLight3.target.position.set(0, 0,0)
    gScene.add(sunLight3)
    const sunLight4 = new THREE.DirectionalLight(0xffffff, 1)
    sunLight4.position.set(0, 1000,3000)
    sunLight4.target.position.set(0, 0,0)
    const sunLight5 = new THREE.DirectionalLight(0xffffff, 3)
    sunLight5.position.set(3000, 1000,3000)
    sunLight5.target.position.set(0, 0,0)
    gScene.add(sunLight5)


    gCamera = new THREE.PerspectiveCamera(50,  canvas.clientWidth / canvas.clientHeight, 0.1, 1000)
    initChaseCamera(gCamera, mainMeshes["Jeep-Chassis"])
    if(window.mobileAndTabletCheck()){
        initMobileControls(cannonVehicle, interactables)
    }
    else{
        initDesktopControls(cannonVehicle, interactables)
    }
    
    gScene.background = new THREE.CubeTextureLoader()
        .setPath('./')
        .load([
            'px.png',
            'nx.png',
            'py.png',
            'ny.png',
            'pz.png',
            'nz.png',
        ])
    mainSceneVisible = true
}



gltfLoader.load('./loadingScene.glb', (loadingSceneGLB) => {
    gScene.add(loadingSceneGLB.scene)
    
    loadingSceneGLB.scene.traverse((child) => {
        loadingScreenMeshes[child.name] = child
        if(child.isMesh && child.name.toLowerCase().includes("loadingtext")){
            child.material = new THREE.MeshBasicMaterial({color:0x1a1004})
            child.castShadow = true
            
        }
        else if(child.isMesh && child.name.toLowerCase().includes("backdrop")){
            child.material = new THREE.ShadowMaterial()
            child.receiveShadow = true
        
            
        }
        else if(child.isMesh && child.name.toLowerCase().includes("saguaro")){
            child.material = new THREE.MeshBasicMaterial({color:0x1a1004})
            child.castShadow = true

        }
    })
    
})





function resizeRendererToDisplaySize(renderer){
    const canvas = renderer.domElement
    const pixelRatio = window.devicePixelRatio
    const width = canvas.clientWidth * pixelRatio | 0
    const height = canvas.clientHeight * pixelRatio | 0
    const needResize = canvas.width  !== width || canvas.height !== height
    if (needResize) {
        renderer.setSize(width, height, false)
    }
    return needResize
}

function render(){
    if(resizeRendererToDisplaySize(gRenderer)){
        let canvas = gRenderer.domElement
        gCamera.aspect = canvas.clientWidth / canvas.clientHeight
        gCamera.updateProjectionMatrix()
    }
    if(mainSceneVisible){
        for(let interactable of interactables){
            if(interactable.inInteractiveRegion(mainMeshes["Jeep-Chassis"].position) && !interactable.isInScene()){
                interactable.addToScene(gScene)
            }
            else if(!interactable.inInteractiveRegion(mainMeshes["Jeep-Chassis"].position) && interactable.isInScene()){
                interactable.removeFromScene(gScene)
            }
        }

        const quaternion = mainMeshes["Jeep-Chassis"].quaternion
        const vector = new THREE.Vector3(1,0,0)
        let rotation = vector.applyQuaternion(quaternion)

        spatialSound.updateListenerPosition(mainMeshes["Jeep-Chassis"].position, rotation)

        for(const object of objectsToUpdate){
            object.mesh.position.copy(object.body.position)
            object.mesh.quaternion.copy(object.body.quaternion)
        }
        gWorld.step(worldStep)
        updateChaseCamera(gCamera, mainMeshes["Jeep-Chassis"])
        ThreeMeshUI.update()
    }
    
    
    gRenderer.render(gScene,gCamera)
    requestAnimationFrame(render)

}



requestAnimationFrame(render)

